<script setup>
import { ref, onMounted, onUnmounted, computed, watch, onUpdated, toRefs } from 'vue'
const props = defineProps({
    data: {
        type: [Array, Object],
        default: () => []
    },
    placeholder: String,
    title: String,
    h: {
        type: String,
        default: 'h-96'
    },
    add: {
        type: Boolean,
        default: false
    },
    id: {
        type: [Number, String],
        default: 0
    },
    disabled: {
        type: Boolean,
        default: false
    },
    ides: String,
    feild: {
        type: String,
        default: null
    },
    status: {
        type: String,
        default: null
    },
    setdefault: {
        type: Boolean,
        default: true
    },
    error: {
        type: [Array, Object],
        default: () => []
    }
})
const emit = defineEmits(['update:id', 'callAdd', 'returnData', 'update:error'])
const show = ref(false)
const inputRef = ref(null)
const svg = ref(null)
const ids = ref(null)
const keyword = ref('')
const check = ref(false)
const placeholder = ref('')
const dataReturn = ref({})
const result = ref('')
const { id, data } = toRefs(props);
const paddingTop = ref(0);
const headerRef = ref(null);

watch([id, data], ([newId, newData], [prevId, prevData]) => {
    if (newId == null) {
        keyword.value = ''
        placeholder.value = props.placeholder
    }

    ids.value = newId

    newData.map(item => {
        if (item.id === props.id) {
            placeholder.value = item.name
            dataReturn.value = item
            emit('returnData', dataReturn.value)
        }
    });

});

watch(ids, (newIds, oldIds) => {
    emit('update:id', ids.value)
    emit('returnData', dataReturn.value)
    emit('update:error', [])
})

onMounted(() => {
    if (headerRef.value) {
        paddingTop.value = headerRef.value.clientHeight;
    }
    setTimeout(function () {
        ids.value = props.id
        if (props.data) {
            props.data.map(item => {
                if (item.id === props.id) {

                    placeholder.value = item.name
                    dataReturn.value = item
                    emit('returnData', dataReturn.value)
                }
            });
        }
    }, 500)
    placeholder.value = props.placeholder
})

function removeAccents(str) {
    return str.normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd')
        .replace(/Đ/g, 'D')
        .replace(/\s+/g, ' ')  // Xóa khoảng trắng thừa giữa các từ
        .trim();
}

const filteredItems = computed(() => {
    const query = removeAccents(keyword.value.toLowerCase());
    return props.data.filter(item =>
        removeAccents(item.name.toLowerCase()).includes(query)
    );
})
const handleClick = () => {
    show.value = true
    svg.value.classList.add('rotate-180')
    check.value = false
    if (keyword.value !== '') {
        placeholder.value = keyword.value
    }
    keyword.value = ''

}
const handleClickSelect = (val) => {
    ids.value = val.id
    keyword.value = val.name
    dataReturn.value = val
    check.value = true
    show.value = false
}
const handleClickDelete = () => {
    ids.value = null
    keyword.value = ''
    dataReturn.value = {}
    placeholder.value = props.placeholder
}

const submit = () => {
    emit('callAdd')
};
const back = () => {
    show.value = false
}
</script>
<template>
    <div class="relative">
        <input ref="inputRef" :id="ides" type="text" @click="handleClick" :disabled="disabled" v-model="keyword"
            class="placeholder-transition bg-white border border-gray-300 text-gray-900 rounded-lg focus:ring-main focus:border-main block w-full pe-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-main dark:focus:border-main"
            autocomplete="off" :class="{
                    'cursor-not-allowed !bg-gray-100' : disabled,
                    'caret-transparent' : true,
                    '!border-red-500' : error && error.length > 0
               }" :placeholder="placeholder">
        <svg v-if="id" @click="handleClickDelete" class="absolute cursor-pointer top-3 right-8 text-[#6e6b7b]"
            xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
        <svg class="absolute top-3 right-3 transition-all text-[#6e6b7b]" ref="svg" xmlns="http://www.w3.org/2000/svg"
            width="15px" height="15px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" role="presentation">
            <polyline points="6 9 12 15 18 9"></polyline>
        </svg>

        <Transition name="slide-up">
            <div v-if="show"  class="fixed top-0 w-full left-0 h-full z-10 bg-white overflow-y-scroll">
                <div ref="headerRef"
                    class="p-4 fixed top-0 w-full z-10 left-0 font-semibold flex items-center justify-between bg-main text-white ">
                    <svg @click="back" class="mr-1.5 -ml-1.5 w-6 h-6 text-white" aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18 17.94 6M18 18 6.06 6" />
                    </svg>
                    <input v-if="!add" type="text" v-model="keyword" autocomplete="off"
                        class="ml-3 bg-main border border-white text-white text-sm rounded-full focus:ring-white placeholder-gray-100 focus:border-white block w-full px-3 p-1.5  dark:bg-main dark:border-white dark:placeholder-white dark:text-white dark:focus:ring-white dark:focus:border-white"
                        placeholder="Tìm kiếm">
                    <div class="font-semibold uppercase text-white" v-if="add">
                        {{title}}
                    </div>
                    <div v-if="add" @click="submit">
                        <i class="fas fa-plus"></i>
                    </div>
                    <!-- <svg class="mr-1.5 -ml-1.5 w-4 h-4 fill-white"
                        xmlns="http://www.w3.org/2000/svg" fill="none" height="24" viewBox="0 0 24 24" width="24">
                        <path
                            d="m7.62095 6.20695c1.19032-.95237 2.63545-1.70695 4.37885-1.70695 4.1421 0 7.5 3.35786 7.5 7.5 0 4.1421-3.3579 7.5-7.5 7.5-3.25492 0-6.02805-2.0746-7.06465-4.9744-.1859-.5201-.71038-.8688-1.25067-.7543l-.97827.2074c-.54029.1145-.89007.6475-.72437 1.1744 1.33923 4.2581 5.31636 7.3469 10.01796 7.3469 5.7989 0 10.5-4.701 10.5-10.5 0-5.79899-4.7011-10.5-10.5-10.5-2.78353 0-4.95165 1.26845-6.51123 2.57458l-1.78168-1.78169c-.286-.286-.71612-.37155-1.08979-.21677-.37368.15478-.61732.51942-.61732.92388v5.5c0 .55228.44772 1 1 1h5.5c.40446 0 .7691-.24364.92388-.61732.15478-.37367.06923-.80379-.21677-1.08979z"
                            fill="#ffffff" />
                    </svg> -->
                </div>
                <div :style="{ paddingTop: '60px' }" class="transition-all"></div>
                
                <div class="p-4">
                    <div v-for="(item,key) in filteredItems" :key="key"
                        class="text-sm p-2 rounded-lg flex items-center justify-between cursor-pointer"
                        @click="handleClickSelect(item)" :class="{
                            ' bg-main text-white' : item.id === ids,
                            'text-gray-400 pointer-events-none ' : item.default && setdefault
                        }">
                        <div>
                            <div class="font-semibold">{{ item.name }}</div>
                            <div class="text-gray-500" v-if="item.address">{{ item.address }}</div>
                            <i v-if="feild">{{ item[feild] }}</i>
                        </div>
                    </div>
                    <div v-if="filteredItems.length === 0" class="py-2 px-5 text-center bg-white">Không có dữ liệu</div>
                </div>
            </div>
        </Transition>
        <p class="text-red-400 not-italic text-sm" v-if="error && error.length > 0">
            {{ error}}
        </p>

    </div>
</template>
